'use client';

import { useEffect } from 'react';
import { getDebugger } from './debug-performance';

// Hook for client components
export function usePerformanceDebug(componentName: string, pageType: string) {
  // Use useEffect to avoid state updates during render
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const debug = getDebugger(pageType);
      debug.log(`COMPONENT_${componentName}_RENDER`);
    }
  }, [componentName, pageType]);
}